import request from '@/utils/request'

// 查询公司信息列表
export function listCompanyInfo(query) {
  return request({
    url: '/web/menu/companylist',
    method: 'get',
    params: query
  })
}

